import styled from "styled-components";

export const ImageButton = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;

  &:focus-visible {
    outline: 3px solid #2b5a42;
    outline-offset: 4px;
  }
`;

export const Img = styled.img<{ $useShadow?: boolean; $useRadius?: boolean; $clickable?: boolean }>`
  max-width: 1440px;
  height: auto;
  ${({ $useShadow }) => $useShadow && "box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);"}
  ${({ $useRadius }) => $useRadius && "border-radius: 8px;"}
  ${({ $clickable }) =>
    $clickable &&
    `
    cursor: pointer;
    transition: transform 0.2s, opacity 0.2s;
    
    &:hover {
      transform: scale(1.01);
      opacity: 0.9;
    }
  `}
`;
